import React from 'react'
import Dashboard from './Components/Card-admin/Dashboard'

function Admin() {
  return (
    <div>
        
    <div>
        <Dashboard/>
    </div>

    </div>
  )
}

export default Admin